export default "__VITE_ASSET__DWVIUl9L__"